import { HeaderButtonsPC } from "../../../Header/loader";
import { HeaderLinksPC } from "../../../Header/HeaderLinksPC";
import PropTypes from "prop-types";
import React from "react";
import {
  ControlCenterComponentType,
  ControlCenterFactory
} from "../../../../components/ControlCenter";
import { links } from "./Config.resource";
import { CollapsableCrossActivity } from "../../../CrossActivity/CollapsableCrossActivity";
import { OddsPC } from "../../../../components/Odds";
import { SettingsPC } from "../../../../components/Settings/loader";
import { useFeature } from "../../../../hooks/useFeature";
import { AppFeatures } from "../../../../constants/featureFlags";
import LogoTypes from "../../../LogoTypes";

const HeaderPC = ({ trackingInfo, searchActive }) => {
  const isSettingsDrawerEnabled = useFeature(AppFeatures.SETTINGS_DRAWER);

  return (
    <div className="headerRightCTA">
      <LogoTypes trackingInfo={trackingInfo} />
      <CollapsableCrossActivity active={searchActive} />
      <ControlCenterFactory
        componentType={ControlCenterComponentType.HeaderButton}
      />
      {!isSettingsDrawerEnabled ? (
        <OddsPC trackingInfo={trackingInfo} />
      ) : (
        <SettingsPC trackingInfo={trackingInfo} />
      )}
      <HeaderLinksPC trackingInfo={trackingInfo} helpLink={links.help} />
      <HeaderButtonsPC trackingInfo={trackingInfo} />
    </div>
  );
};

HeaderPC.propTypes = {
  trackingInfo: PropTypes.object,
  searchActive: PropTypes.bool
};

export default React.memo(HeaderPC);
